// extracted by mini-css-extract-plugin
export var searchHeader = "_6w-0";
export var searchHeaderDark = "_6w-1";